// removed by extract-text-webpack-plugin
module.exports = {"Card":"sGN6k68SAQKqreRmZasHN","Body":"_2JdPmEGBohjGCsz9tbL9qy","Group":"_3PRkP3nTpNjn--fXibwo6","Title":"_2EzsjwccMpvPU80Nxq38yx","Column":"_1NTjtsYJLKfJLeZsBGXrz9","CheckboxWrap":"_1C8uMdafb2Sk_ODQCmpAMg","CustomCheckbox":"_3Q_b6LM3wqJRhp2aJ_mvX8","InputIcon":"_2Haz2vVh80Q_v5XIH1wulC","ActiveIcon":"_3qbNl85Uiw6hhi5fOF8xjL","BlockIcon":"_13c--_pey0evRgeLWfT8pX","Footer":"_3MbEBJASNZ3tBHHQabRTiE","Submit":"_TPH0MtyAqVXfQlGfENst","buttonIcon":"_2j0PRwEjOQ1beee7RLVEIo"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/ComponentsOfAdministrator/TerminalsFilters/styles.module.css
// module id = 549
// module chunks = 0